import ExtLink, { buildLink } from './ExtLink';

export { buildLink };
export default ExtLink;
